import PresentacionUpdateView from './views/PresentacionUpdateView.vue'
import PresentacionUpdateListView from './views/PresentacionUpdateListView.vue'

export default [
  {
    path: '/actualizacion/:id',
    name: 'actualizacion',
    component: PresentacionUpdateView
  },
  {
    path: '/actualizaciones',
    name: 'actualizaciones',
    component: PresentacionUpdateListView
  }
]
